import { render, staticRenderFns } from "./foodCourtDetails.vue?vue&type=template&id=4a2bdb79&scoped=true&"
import script from "./foodCourtDetails.vue?vue&type=script&lang=js&"
export * from "./foodCourtDetails.vue?vue&type=script&lang=js&"
import style0 from "./foodCourtDetails.vue?vue&type=style&index=0&id=4a2bdb79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bdb79",
  null
  
)

export default component.exports